import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = { class: "nav nav-tabs mb-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "ms-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_material_table = _resolveComponent("material-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Emission Factor",
        text: "Raw material configuration",
        class: "mb-0"
      }),
      (_ctx.canCreate)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editConfiguration(null)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Add Configuration",
              text: "Add Configuration"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "nav-item pointer",
                key: tab.type
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", { 'active': _ctx.activeTab == tab.type }]),
                  onClick: ($event: any) => (_ctx.activeTab = tab.type)
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: tab.label,
                    text: tab.label
                  }, null, 8, ["localizedKey", "text"]),
                  _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(_ctx.itemsByType[tab.type].length) + ")", 1)
                ], 10, _hoisted_4)
              ]))
            }), 128))
          ]),
          (_openBlock(), _createBlock(_component_material_table, {
            key: _ctx.activeTab,
            items: _ctx.itemsByType[_ctx.activeTab],
            materialType: _ctx.activeTab,
            onEdit: _ctx.editConfiguration
          }, null, 8, ["items", "materialType", "onEdit"]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}